export const FREE_CALL_CALENDAR_LINK =
  'https://calendly.com/ayble-team/learn-more-about-ayble';
export const LOCAL_STORAGE_USER_INFO_KEY = 'ayble-user-info';

// Base URL for the Ayble Intercom workspace (a single workspace shared across
// environments). Combine with a member's `intercom_id` to open their inbox.
export const INTERCOM_APP_URL = 'https://app.intercom.com/a/apps/humxgh5j';

// URL to a member's all-conversations view in Intercom.
export const getIntercomConversationsUrl = (intercomId) =>
  `${INTERCOM_APP_URL}/users/${intercomId}/all-conversations`;
